import React from 'react';
import './style.css';
import { ReactComponent as Blue } from '../../../../assets/images/TicketImages/blue.svg';
import { ReactComponent as Green } from '../../../../assets/images/TicketImages/green.svg';
import { ReactComponent as Yellow } from '../../../../assets/images/TicketImages/yellow.svg';
import { ReactComponent as Orange } from '../../../../assets/images/TicketImages/orange.svg';
import { ReactComponent as Red } from '../../../../assets/images/TicketImages/red.svg';

function SubmitMenu() {
  const data = [
    {
      id: 0,
      title: 'Submit as Open',
      Icon: <Blue />,
    },
    {
      id: 1,
      title: 'Submit as Solved',
      Icon: <Green />,
    },
    {
      id: 2,
      title: 'Submit as Pending',
      Icon: <Yellow />,
    },
    {
      id: 3,
      title: 'Submit as On Hold',
      Icon: <Orange />,
    },
    {
      id: 4,
      title: 'Submit as Closed',
      Icon: <Red />,
    },
  ];

  return (
    <div className="submitMenu-Container">
      {data.map((item) => (
        <div key={item.id} className="PublicMenu-Main">
          {item.Icon}
          <p>{item.title}</p>
        </div>
      ))}
    </div>
  );
}
export default SubmitMenu;
